module.exports = __webpack_public_path__ + "static/media/apple-crate.293731f3.svg";